/* eslint-disable */
import React, { useContext } from 'react';
import { useNavigate } from 'react-router';

// Custom Components
import PhotoCentricPage from '@/ui/PhotoCentric/PhotoCentricPage';
import modelRasvjetaMjesta from '@/models/rasvjeta_mjesta';
import Permissions from '@/lib/permissions';
import UserContext from '@/context/UserContext/UserContext';
import AppPage from '@/ui/AppPage/AppPage';

type RasvjetaMjestaPhotoCentricPageParams = {};

const RasvjetaMjestaPhotoCentricPage = (props: RasvjetaMjestaPhotoCentricPageParams) => {
  const userContext = useContext(UserContext);

  const navigate = useNavigate();

  const handleCustomAction = (
    action: string,
    id: number,
    record?: { [key: string]: any }
  ) => {
    let locationId: number | null = null;
    if (record && 'lokacija_id' in record) {
      locationId = record.lokacija_id as number;
    }
    switch (action) {
      case 'show_object':
        if (id) {
          const url = `${
            location.origin
          }/rasvjeta/mjesta/?id=${id.toString()}&open_first=true`;
          window.open(url, '_blank');
        }
        break;
      case 'show_photos':
        if (id) {
          const url = `${
            location.origin
          }/ena/photodoc/?rec_id=${id.toString()}`;
          window.open(url, '_blank');
        }
        break;
      default:
        break;
    }
  };

  const viewName = userContext?.hasAnyPermission([Permissions.ThreeDView])
    ? 'processing_with_3d'
    : 'processing';

  return (
    <AppPage titlett="ena:page.photodoc" needPermission={[Permissions.RasvjetaPhotodoc]}>
      <PhotoCentricPage
        titleToken="titles.rasvjeta_mjesta"
        model={modelRasvjetaMjesta}
        mapId={32}
        onCustomTableAction={handleCustomAction}
        viewName={viewName}
      />
    </AppPage>
  );
};

export default RasvjetaMjestaPhotoCentricPage;
